module.exports = __webpack_public_path__ + "img/driver2.9588e380.png";